import fetch from 'auth/FetchInterceptor'

const URL_BASE =
  process.env.NODE_ENV === "development"
	? process.env.REACT_APP_API_URL
	: process.env.REACT_APP_API_URL_PROD;

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: `${URL_BASE}/login`,
		method: 'post',
		data: data
	})
}


AuthService.loginPin = function (data) {
	return fetch({
		url: `${URL_BASE}/login-with-pin`,
		method: 'post',
		data: data
	})
}


AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;